document.getElementById('initing').innerHTML = 'Loading...';

// should be imported first as some other module might try to use window.console
import '~/misc/fakeConsole';
import Cookies from 'js-cookie'
import {browserHistory} from 'react-router';
import initialRender from '~/render';
import store from './store';
import {initUser, setTokenToUser} from '~/modules/user/actions';
import {getSwitchData} from '~/modules/dots/actions';
import {getRateSwitch} from '~/modules/rate/actions';
import {getSwitchTimes} from '~/modules/window/actions';
import {memberSwitch} from '~/modules/premiumSwitch/actions';
import {create as createInstallationId} from '~/modules/installation/actions';
import initialMetrics from './initialmetrics';
import shutdown from './shutdown';
import observe from './observe';
import recoverRoute from './routing/recover';
import {track, trackEnvProps} from '~/misc/metrics';
import {flat} from '~/misc/metrics/utils';
import config, {commonEnvProps} from './config';
import {getUrlQeury} from '~/misc/formatUrlquery';
import {tipsChange} from '~/modules/tips/actions';
import {getGeolocation} from '~/misc/geolocation';
import { getPrice } from './pages/FuelSurchargePage/state/action';
// import VConsole from 'vconsole/dist/vconsole.min.js';
// // // import vconsole
// let vConsole = new VConsole();

getGeolocation();

// get token from url
const getToken = () => {
  const query = getUrlQeury();
  const token = query.token;
  if(query.action === 'signout'){
    window.localStorage.removeItem('sessionToken');
    return "";
  }
  if ((token === 'undefined') || (token === 'null') || !token) {
    return false;
  }
  return token;
};

trackEnvProps(commonEnvProps);
//recoverRoute(store, browserHistory);
observe(store);

document.addEventListener('click', (e) => {
  if (e.toElement && e.toElement.id && e.toElement.id == 'sb-link') {
    track('Web Referral Banner', {
      'Web Referral Banner': 1
    });
  }
},false);

const token = getToken();
if (token !== false) {
  store.dispatch(setTokenToUser(token));
}

store.dispatch(getSwitchData());
store.dispatch(getRateSwitch());
store.dispatch(getSwitchTimes());
store.dispatch(memberSwitch());
store.dispatch(initUser());
if (getUrlQeury().source === 'email_verify') {
  setTimeout(() => {
    store.dispatch(tipsChange(
      {type: 'success', source: 'email_verify'},
      'Your email address has already been confirmed.'
    ));
  }, 1000);
}

store.dispatch(getPrice());

// store.dispatch(createInstallationId()).then(initialRender, initialRender);
initialRender()
initialMetrics(store);

window.addEventListener('beforeunload', () => shutdown(store));
if (window.Intercom) {
  window.Intercom('boot', {
    app_id: config.intercom,
    ...flat(commonEnvProps, '__'),
  });
}



// WEBPACK FOOTER //
// ./src/index.js